import React from 'react';
import { Card, CardContent, CardHeader, Skeleton, Stack } from '@mui/material';

interface SkeletonTableProps {
  rows?: number;
}

function SkeletonTable({ rows = 3 }: SkeletonTableProps) {
  return (
    <Card>
      <CardHeader
        title={<Skeleton variant="text" width={180} height={28} />}
        action={<Skeleton variant="rectangular" width={100} height={32} />}
      />
      <CardContent>
        <Stack spacing={1}>
          {/* Table header */}
          <Stack direction="row" spacing={2} sx={{ pb: 1 }}>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Stack>
          {/* Table rows */}
          {Array.from({ length: rows }).map((_, i) => (
            <Stack key={i} direction="row" spacing={2} sx={{ py: 1 }}>
              <Skeleton variant="text" width={80} height={24} />
              <Skeleton variant="text" width={120} height={24} />
              <Skeleton variant="text" width={100} height={24} />
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default SkeletonTable;
